import { DateTime } from 'luxon';

import { Scatter } from 'constants/colors';

import { getRangeColorRefRangesByLabel } from './Icons';

export const getScatterRangeColor = (colorName: string) => {
  switch (colorName) {
    case 'categoryRed':
    case 'categoryFireRed':
      return Scatter.red;
    case 'categoryGreen':
    case 'categoryNormalGreen':
      return Scatter.green;
    case 'categoryYellow':
      return Scatter.yellow;
    case 'categoryOrange':
      return Scatter.orange;
    case 'categoryBestGreen':
      return Scatter.green2;
  }
};

/**
 * Gets the correct min/max values for graph display
 * @param startDate the first date of the range
 * @param endDate the last date of the range
 * @param period monthly or yearly range
 * @returns the min and max values for this time range
 */
export const getMinMaxSpread = (startDate: DateTime, endDate: DateTime, period: IPeriod) => {
  const min = startDate.startOf('day').toMillis();
  let max = endDate.endOf('day').toMillis();
  switch (period) {
    case 'monthly':
      max = endDate.endOf('month').toMillis();
      break;
    case 'yearly':
      max = endDate.endOf('year').toMillis();
      break;
  }
  return { min, max };
};

export const round = (number: number, decimals: number) => {
  // Math.round(x * 10^y) / 10^y returns x with y decimals
  const powerOfTen = Math.pow(10, decimals);
  return Math.round(number * powerOfTen) / powerOfTen;
};

export const selectValueForClass = (className: string, valueType: string, dataset: any[]) => {
  if (className === 'pressure') {
    const value =
      valueType === 'smallest'
        ? parseFloat(dataset[0].diastolic) || 0
        : parseFloat(dataset[0].systolic) || 0;
    return value;
  } else {
    return parseFloat(dataset[0].value);
  }
};

export const getRefRangeColorByValue = (
  className: IMeasurementClassType,
  refRanges: ICarePlanReferenceRange[],
  value: number
) => {
  let currentZoneLabel = '';
  refRanges
    .find((x) => x.measurement_class === className)
    ?.zones.map((zone) => {
      const low = Number(zone.low);
      const high = Number(zone.high);
      if (!low && value < high) currentZoneLabel = zone.label;
      if (!high && value > low) currentZoneLabel = zone.label;
      if (value >= low && value < high) currentZoneLabel = zone.label;
    });
  return getRangeColorRefRangesByLabel(currentZoneLabel, false) || '#fff';
};
